import { Injectable } from '@angular/core';
import { LocalStorageService } from './localstorage.service';
import { AppService } from '../api.service';
import { ProjectsService } from './project.service';

interface SearchLog {
  query: string;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root',
})
export class SearchLogService {
  private searchKey = 'searchQueries'; // Key to store search logs in localStorage
spaecs:any[]=[]
  constructor(private localStorageService: LocalStorageService,private _as:AppService,private _project:ProjectsService) { }

  // Save a search query with the current date and time if it doesn't already exist
  saveSearchQuery(query: string): void {
    const searchQueries = this.getSearchQueries();

    // Check if the query already exists (case-insensitive comparison)
    const queryExists = searchQueries.some(q => q.query.toLowerCase() === query.toLowerCase());

    if (!queryExists) {
      const newLog: SearchLog = { query, timestamp: new Date() }; // Create a new log entry
      searchQueries.unshift(newLog); // Add the new log entry to the beginning
      this.localStorageService.setItem(this.searchKey, JSON.stringify(searchQueries));
    }
  }

  // Get all search queries
  getSearchQueries(): SearchLog[] {
    const queries = this.localStorageService.getItem(this.searchKey);
    return queries ? JSON.parse(queries) : [];
  }

  // Delete a specific search query by comparing both query and timestamp
  deleteSearchQuery(log: SearchLog): void {
    let searchQueries = this.getSearchQueries();

    // Filter out the query log to delete (match both query and timestamp)
    searchQueries = searchQueries.filter(
      q => q.query !== log.query || new Date(q.timestamp).getTime() !== new Date(log.timestamp).getTime()
    );

    this.localStorageService.setItem(this.searchKey, JSON.stringify(searchQueries));
  }

  // Clear all search queries
  clearSearchQueries(): void {
    this.localStorageService.removeItem(this.searchKey);
  }

  getAllSpacesWidthProductCount(){
    
    const url = this._as.api_base_url + 'search/space-product-colllection/' + this._project.selectedProject.id  + '/';
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
      
        this.spaecs = res.spaces;
       
        // this.results = res.results;
      });
  }
}
